import type { ListItemButtonProps } from '@mui/material';
import { ListItemButton } from '@mui/material';
import { blueGrey } from '@mui/material/colors';
import type { MouseEvent } from 'react';
import React from 'react';
import type { NavLinkProps } from 'react-router-dom';
import { NavLink } from 'react-router-dom';

export const ListItemButtonLink = React.forwardRef<HTMLButtonElement, ListItemButtonProps & NavLinkProps>((props, ref) => {
  const { children, ...otherProps } = props;

  const isActive = otherProps.to === window.location.pathname;

  return (
    <ListItemButton
      component={NavLink}
      ref={ref}
      {...otherProps}
      onClick={(event: MouseEvent) => isActive && event.preventDefault() }
      sx={{
        color: blueGrey[300],
        '&:hover': {
          backgroundColor: blueGrey[900],
        },
        ...otherProps.sx,
      }}
    >
      {children}
    </ListItemButton>
  );
});